
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliveryMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"deliveryMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleRequirements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"carrierIntegrationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"integrationIdentifier"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enhancement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shipTheoryIncrement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"carriageCalculationMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chargeBasis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chargeMatrix"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cost"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"vatProductCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nominal"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountNo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"dispatchEmailEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesMonday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesTuesday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesWednesday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesThursday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesFriday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesSaturday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noDeliveriesSunday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usesDeliveryRoute"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amazonDeliveryServiceName"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":893}};
    doc.loc.source = {"body":"query DeliveryMethod($id: Long) {\n  data: deliveryMethod(id: $id) {\n    id\n    concurrencyVersion\n    uuid\n    vehicleRequirements\n    carrier {\n      id\n      concurrencyVersion\n      name\n      carrierIntegrationType\n      integrationIdentifier\n    }\n    description\n    serviceLevel\n    enhancement\n    shipTheoryIncrement\n    leadTime\n    carriageCalculationMethod\n    chargeBasis\n    chargeMatrix {\n      id\n      concurrencyVersion\n      key\n      value\n      cost\n    }\n    vatProductCategory {\n      id\n      concurrencyVersion\n      description\n    }\n    nominal {\n      id\n      concurrencyVersion\n      name\n      accountNo\n    }\n    dispatchEmailEnabled\n    noDeliveriesMonday\n    noDeliveriesTuesday\n    noDeliveriesWednesday\n    noDeliveriesThursday\n    noDeliveriesFriday\n    noDeliveriesSaturday\n    noDeliveriesSunday\n    usesDeliveryRoute\n    amazonDeliveryServiceName\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DeliveryMethod"] = oneQuery(doc, "DeliveryMethod");
        
